import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../Redux/languageSlice";
import brandLogo from "./../assets/brand.png";

const MobileSecondFooter = () => {
  const getLanguageMessages = (language) => {
    switch (language) {
      case "en":
        return require("../lang/en.json");
      case "fr":
        return require("../lang/fr.json");
      case "es":
        return require("../lang/es.json");
      case "pt":
        return require("../lang/pt.json");
      default:
        return require("../lang/en.json");
    }
  };

  const dispatch = useDispatch();
  const selectedLanguage = useSelector((state) => state.language);

  const handleLanguageChange = (language) => {
    dispatch(setLanguage(language));
    localStorage.setItem("language", JSON.stringify(language));
  };

  // Language options for the select dropdown
  const languageOptions = [
    { value: "en", label: "English" },
    { value: "fr", label: "Français" },
    { value: "es", label: "Español" },
    { value: "pt", label: "Português" },
  ];

  // Link styling
  const linkStyle = {
    color: "#5D6D7E",
    textDecoration: "none",
    fontFamily: "'Montserrat', sans-serif",
    fontSize: "0.85rem",
    fontWeight: 500,
    margin: "0.5rem 0.7rem",
    transition: "color 0.2s ease",
    letterSpacing: "0.2px",
    display: "inline-block"
  };

  // Language selector styling
  const selectStyle = {
    padding: "8px 12px",
    borderRadius: "4px",
    border: "1px solid #e0e0e0",
    backgroundColor: "white",
    fontFamily: "'Montserrat', sans-serif",
    fontSize: "0.9rem",
    color: "#2C3E50",
    margin: "15px 0",
    width: "150px"
  };

  return (
    <footer
      style={{ 
        width: "100%", 
        backgroundColor: "#f8f9fa", 
        borderTop: "1px solid #e0e0e0",
        padding: "25px 0 20px"
      }}
    >
      <Container>
        {/* Logo Section */}
        <Row className="justify-content-center mb-3">
          <Col xs={12} className="text-center mb-3">
            <img 
              src={brandLogo} 
              alt="Verto Logo" 
              style={{ 
                width: "150px", 
                height: "auto", 
                marginBottom: "15px" 
              }} 
            />
          </Col>
        </Row>
        
        {/* Language Selector */}
        <Row className="justify-content-center mb-3">
          <Col xs={12} className="text-center">
            <select 
              value={selectedLanguage} 
              onChange={(e) => handleLanguageChange(e.target.value)}
              style={selectStyle}
            >
              {languageOptions.map((language) => (
                <option key={language.value} value={language.value}>
                  {language.label}
                </option>
              ))}
            </select>
          </Col>
        </Row>
        
        {/* Footer Links */}
        <Row className="justify-content-center">
          <Col xs={12}>
            <div className="d-flex flex-wrap justify-content-center">
              <Link 
                to="/ethics" 
                style={linkStyle}
                onMouseOver={(e) => e.target.style.color = "#3498DB"}
                onMouseOut={(e) => e.target.style.color = "#5D6D7E"}
              >
                {getLanguageMessages(selectedLanguage).footerLinks.ethics}
              </Link>
              <Link 
                to="/terms" 
                style={linkStyle}
                onMouseOver={(e) => e.target.style.color = "#3498DB"}
                onMouseOut={(e) => e.target.style.color = "#5D6D7E"}
              >
                {getLanguageMessages(selectedLanguage).footerLinks.terms}
              </Link>
              <Link 
                to="/privacy" 
                style={linkStyle}
                onMouseOver={(e) => e.target.style.color = "#3498DB"}
                onMouseOut={(e) => e.target.style.color = "#5D6D7E"}
              >
                {getLanguageMessages(selectedLanguage).footerLinks.privacy}
              </Link>
              <Link 
                to="/press" 
                style={linkStyle}
                onMouseOver={(e) => e.target.style.color = "#3498DB"}
                onMouseOut={(e) => e.target.style.color = "#5D6D7E"}
              >
                {getLanguageMessages(selectedLanguage).footerLinks.press}
              </Link>
              <Link 
                to="/cookies-policy" 
                style={linkStyle}
                onMouseOver={(e) => e.target.style.color = "#3498DB"}
                onMouseOut={(e) => e.target.style.color = "#5D6D7E"}
              >
                {getLanguageMessages(selectedLanguage).footerLinks.cookiesPolicy}
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default MobileSecondFooter;